import { gql } from "@apollo/client";
import {
  PROJECT_PACKAGE_DETAIL_FIELDS,
  PROJECT_PACKAGE_ITEM_FIELDS,
  PROJECT_QUESTION_FIELDS,
  PROJECT_TYPE_FIELDS,
} from "./query";

export const CREATE_PROJECT_TYPE = gql`
  mutation CreateProjectType($input: ProjectTypeWriteInput!) {
    projectConfig {
      createProjectType(input: $input) { ${PROJECT_TYPE_FIELDS} }
    }
  }
`;

export const UPDATE_PROJECT_TYPE = gql`
  mutation UpdateProjectType($id: ID!, $input: ProjectTypeWriteInput!) {
    projectConfig {
      updateProjectType(id: $id, input: $input) { ${PROJECT_TYPE_FIELDS} }
    }
  }
`;

export const SET_PROJECT_TYPE_VISIBILITY = gql`
  mutation SetProjectTypeVisibility($id: ID!, $isVisible: Boolean!) {
    projectConfig {
      setProjectTypeVisibility(id: $id, isVisible: $isVisible) { ${PROJECT_TYPE_FIELDS} }
    }
  }
`;

export const CREATE_PROJECT_QUESTION = gql`
  mutation CreateProjectQuestion($projectTypeId: ID!, $input: ProjectQuestionWriteInput!) {
    projectConfig {
      createProjectQuestion(projectTypeId: $projectTypeId, input: $input) { ${PROJECT_QUESTION_FIELDS} }
    }
  }
`;

export const UPDATE_PROJECT_QUESTION = gql`
  mutation UpdateProjectQuestion($id: ID!, $input: ProjectQuestionWriteInput!) {
    projectConfig {
      updateProjectQuestion(id: $id, input: $input) { ${PROJECT_QUESTION_FIELDS} }
    }
  }
`;

export const DELETE_PROJECT_QUESTION = gql`
  mutation DeleteProjectQuestion($id: ID!) {
    projectConfig {
      deleteProjectQuestion(id: $id)
    }
  }
`;

export const REORDER_PROJECT_QUESTIONS = gql`
  mutation ReorderProjectQuestions($projectTypeId: ID!, $questionIds: [ID!]!) {
    projectConfig {
      reorderProjectQuestions(projectTypeId: $projectTypeId, questionIds: $questionIds) { ${PROJECT_QUESTION_FIELDS} }
    }
  }
`;

export const CREATE_PROJECT_PACKAGE = gql`
  mutation CreateProjectPackage($input: ProjectPackageWriteInput!) {
    projectConfig {
      createProjectPackage(input: $input) { ${PROJECT_PACKAGE_DETAIL_FIELDS} }
    }
  }
`;

export const UPDATE_PROJECT_PACKAGE = gql`
  mutation UpdateProjectPackage($id: ID!, $input: ProjectPackageWriteInput!) {
    projectConfig {
      updateProjectPackage(id: $id, input: $input) { ${PROJECT_PACKAGE_DETAIL_FIELDS} }
    }
  }
`;

export const DELETE_PROJECT_PACKAGE = gql`
  mutation DeleteProjectPackage($id: ID!) {
    projectConfig {
      deleteProjectPackage(id: $id)
    }
  }
`;

export const SET_PROJECT_PACKAGE_VISIBILITY = gql`
  mutation SetProjectPackageVisibility($id: ID!, $isVisible: Boolean!) {
    projectConfig {
      setProjectPackageVisibility(id: $id, isVisible: $isVisible) { ${PROJECT_PACKAGE_ITEM_FIELDS} }
    }
  }
`;
